import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const MarketplaceProducts = () => import('./views/Index.vue');

export default [
  {
    path: '/marketplace-products',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketplaceadmin' },
    children: [
      {
        path: '',
        name: 'MarketplaceProducts',
        component: MarketplaceProducts,
        meta: { title: i18n.global.t('marketplace.products') },
      },
    ],
  },
];
